"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Separator } from "@/components/ui/separator";
export default function Narrative() {
  const shouldReduceMotion = useReducedMotion();
  const animationProps = shouldReduceMotion ? {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    }
  } : {
    initial: {
      opacity: 0,
      y: 16
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.3
    },
    transition: {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="core-narrative" data-nav="light" className="relative w-full bg-background py-20 md:py-28 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-5xl">
        <motion.div {...animationProps} className="flex flex-col items-center">
          {/* Top Hairline Divider with Orbit Motif */}
          <div className="w-full flex items-center justify-center gap-4 mb-10 md:mb-14">
            <Separator className="flex-1 bg-border/60" />
            <div className="flex items-center justify-center size-8 rounded-full border border-border/60 bg-background relative shrink-0">
              <span className="size-1.5 rounded-full bg-primary/80" />
              <div className="absolute inset-0 rounded-full border border-border/40 scale-125" />
            </div>
            <Separator className="flex-1 bg-border/60" />
          </div>

          {/* Editorial Category Label */}
          <span className="text-[0.8125rem] font-medium tracking-[0.15em] uppercase text-muted-foreground mb-6 text-center">
            The Anchor &amp; Orbit Framework
          </span>

          {/* Centered Editorial Quote Block */}
          <blockquote className="relative text-center px-4 md:px-8">
            <p className="font-serif text-xl sm:text-2xl md:text-3xl lg:text-4xl text-foreground font-normal italic leading-relaxed md:leading-snug tracking-tight">
              &ldquo;At the heart of our travel design is our trademarked Anchor &amp; Orbit method—a proprietary framework developed specifically for multi-generational expeditions. This approach allows the family to remain anchored together for meaningful shared experiences and legacy-building, while providing individuals the freedom to orbit outwardly and pursue their own unique passions. It perfectly balances group togetherness with individual freedom, entirely eliminating logistical friction.&rdquo;
            </p>
          </blockquote>

          {/* Bottom Hairline Divider with Orbit Motif */}
          <div className="w-full flex items-center justify-center gap-4 mt-10 md:mt-14">
            <Separator className="flex-1 bg-border/60" />
            <div className="flex items-center justify-center size-8 rounded-full border border-border/60 bg-background relative shrink-0">
              <span className="size-1.5 rounded-full bg-primary/80" />
              <div className="absolute inset-0 rounded-full border border-border/40 scale-125" />
            </div>
            <Separator className="flex-1 bg-border/60" />
          </div>
        </motion.div>
      </div>
    </section>;
}